export default __webpack_public_path__ + "static/media/send-gift-background.9685d726.png";